import { customAlphabet } from 'nanoid'

const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 22)

/**
 * Generates a unique ID.  Currently using a 22-character [nanoid|https://github.com/ai/nanoid] with
 * an alphabet that includes 0-9, a-z, A-Z.
 *
 * @returns {string} A unique ID.
 */
export function createId() {
  return nanoid()
}

// Short, human-friendly slug for participation links. The alphabet omits visually ambiguous
// characters (0/O, 1/l/I) so slugs are easy to read aloud and type. 8 chars over a 56-char
// alphabet gives ~9.6e13 combinations; scoped per-decision, collisions are effectively nil —
// but callers must still handle collisions (conditional write + retry).
const nanoidSlug = customAlphabet('23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz', 8)

/**
 * Generates a short (8-character) slug for participation-session links.
 *
 * @returns {string} A short slug.
 */
export function createSlug() {
  return nanoidSlug()
}
